import { Box, IconButton, Typography } from '@material-ui/core';
import './AlertCard.scss';
import AlertArrowRight from 'assets/icons/AlertArrowRight';
import AlertBarraGray from 'assets/icons/AlertBarraGray';
import InfoModalIcon from 'assets/icons/InfoModalIcon';
interface AlertCardProps {
  showAlert: boolean;
}

export const AlertCard = ({ showAlert }: AlertCardProps) => {

  if (!showAlert) return null;

  const handleClick = () => {
    window.open('https://forms.office.com/Pages/ResponsePage.aspx?id=TJYjMh9uuki3BUIzUSgajE-Rlhp25_hHrKngbzn4OYdUMTBBSERIRkszQzhYVzg2REo4Q1BVSkhJTyQlQCN0PWcu', '_blank');
  };

  return (
    <div id='container_box'>
      <Box className='alert-card-container'>
        <AlertBarraGray />
        <Box className='content-container'>
          <InfoModalIcon />
          <Typography className='alert_card_text'>
            Ajude a transformar a ferramenta! Responda nossa pesquisa em menos de 7 minutos.
          </Typography>
          <Box display='flex' alignItems='left'>
            <IconButton
              size='small'
              className='alert_container_arrow'
              onClick={handleClick}
            >
              <span className='alert_card_text_link'>Ir para pesquisa</span>
              <span className='alert_icon_arrow'>
                <AlertArrowRight />
              </span>
            </IconButton>
          </Box>
        </Box>
      </Box>
    </div>
  );
};